package com.example.mystybag.core.model

data class BaseUIState(
    var showProgress        : Boolean = false,
    var bottomSheetIsOpen   : Boolean = false,
    var userCanClose        : Boolean = true,
    var hideKeyboard        : Boolean = false,
    var showKeyboard        : Boolean = false,
    var clearFocus          : Boolean = false,
    var showTopBar          : Boolean = false
)
